import React from 'react';
import PropTypes from 'prop-types';

import { Heading, Paragraph } from '@zillow/constellation';
import { WizardStep } from '@zillow/zrs-rental-applications';

export default function AccessUnavailableStep({ id }) {
  return (
    <WizardStep label="Access Unavailable" id={id} hidden>
      <Heading marginBottom="sm" level={4} as="h2">
        Access unavailable
      </Heading>
      <Paragraph marginBottom="md">
        Your account isn’t set up with user permissions necessary for you to access applications.
      </Paragraph>
      <Paragraph>
        First, someone on your account needs to become the application manager. Then, they can assign you permission to
        access applications.
      </Paragraph>
    </WizardStep>
  );
}

AccessUnavailableStep.propTypes = {
  id: PropTypes.string.isRequired,
};
